import { PartTypeSchema, PartTypeType } from "../types";

export const isSquarePartType = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  switch (partType) {
    case PartTypeSchema.enum.SQUARE_TUBE:
    case PartTypeSchema.enum.SQUARE_BAR:
      return true;
    default:
      return false;
  }
};
